import { render, staticRenderFns } from "./szjx.vue?vue&type=template&id=155fbbc6&"
import script from "./szjx.vue?vue&type=script&lang=ts&"
export * from "./szjx.vue?vue&type=script&lang=ts&"
import style0 from "./szjx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports